<template>
  <card
    dis-hover
    :padding="8"
    class="payments-item"
    @click.native="openPayment"
  >
    <div class="payments-item__common-info">
      <div class="payments-item__name ms-subhead" v-if="payment.date">
        Платеж от {{ formatDefaultDate(payment.date) }}
      </div>
      <tag color="primary" class="ms-costs">
        {{ getFormattedCosts(payment.value, false, payment.contract_with_vat) }}
      </tag>
    </div>
    <div :class="`payments-item__project-info ${all ? 'full-width' : ''}`">
      <div class="payments-item__project-customer ms-text">
        Отправитель: <b>{{ payment.from_company }}</b>
      </div>
      <div class="payments-item__project-name ms-help ms-ellipsis" v-if="all">
        <ellipsis-text
          :max-width="320"
          :text="`${payment.contract_code}. ${payment.contract_name}`"
        />
      </div>
    </div>
    <div class="payments-item__act-info">
      <tag v-if="payment.type_id === 2" color="default">Аванс</tag>
      <template v-else>
        <div class="payments-item__act-name ms-small-head">
          Акт №{{ payment.act_number }}
        </div>
        <tag color="default">
          {{
            getFormattedCosts(
              payment.act_cost,
              false,
              payment.contract_with_vat
            )
          }}
        </tag>
      </template>
    </div>
  </card>
</template>

<script>
import EllipsisText from '@/components/parts/ellipsis-text'
import { getFormattedCosts, formatDefaultDate } from '@/utils'

export default {
  props: ['payment', 'all'],
  components: {
    EllipsisText
  },
  methods: {
    openPayment () {
      if (this.all) this.$store.commit('SET_COME_FROM', 'payments')

      this.$emit('open-payment', {
        id: this.payment.id,
        contract_id: this.payment.contract_id
      })
    },
    getFormattedCosts,
    formatDefaultDate
  }
}
</script>

<style lang="less">
.payments-item {
  margin-bottom: 4px;
  cursor: pointer;

  &:hover {
    border-color: rgba(@primary-color, 0.6) !important;
  }

  .ivu-tag {
    margin: 0;
    width: 182px;
    text-align: center;
  }

  .ivu-card-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__common-info {
    display: flex;
    align-items: center;
    width: 40%;
    flex-shrink: 0;
    padding-left: 4px;
  }

  &__project-info {
    display: flex;
    flex-direction: column;

    &.full-width {
      flex: 1;
    }
  }

  &__project-name {
    width: 320px;
  }

  &__name {
    margin-right: 16px;
  }

  &__act-info {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
    width: 30%;
  }

  &__act-name {
    margin-right: 16px;
  }
}
</style>
